import React, { useContext } from 'react';
import { isMobileOrTablet } from '../../../../utils/browserDetection';
import Filter from '../Filter';
import DateSelect from '../Filter/DateSelect';
import DateValue from '../Filter/DateValue';
import LocationSelect from '../Filter/LocationSelect';
import LocationValue from '../Filter/LocationValue';
import SportSelect from '../Filter/SportSelect';
import SportValue from '../Filter/SportValue';
import TagSelect from '../Filter/TagSelect';
import TagValue from '../Filter/TagValue';
import CovidSelect from '../Filter/CovidSelect';
import CovidValue from '../Filter/CovidValue';
import TagFilterWrapper from '../Filter/TagFilterWrapper';
import DistanceSelect from '../Filter/DistanceSelect';
import DistanceValue from '../Filter/DistanceValue';
import DistanceFilterWrapper from '../Filter/DistanceFilterWrapper';
import DiscoveryContext from '../../../../contexts/discoveryContext/contextV2';
import { filterBarContainer } from './styles.module.css';

const FilterBar = () => {
  const {
    defaultFilters: {
      date: defaultDateFilters,
      distance: defaultDistanceFilters,
      location: defaultLocationFilters,
      tag: defaultTagFilters,
      sport: defaultSportFilters,
      covid: defaultCovidFilters,
    },
  } = useContext(DiscoveryContext);

  return (
    <div className={filterBarContainer}>
      <Filter
        type="Sport"
        modalTitle="Filter by Sport"
        valueComponent={SportValue}
        filterComponent={SportSelect}
        defaultFilters={defaultSportFilters}
      />
      <Filter
        type="date"
        modalTitle="Filter by Date"
        valueComponent={DateValue}
        filterComponent={DateSelect}
        defaultFilters={defaultDateFilters}
      />
      <DistanceFilterWrapper>
        {({ isDistanceFilterVisible }) =>
          isDistanceFilterVisible ? (
            <Filter
              type="distance"
              modalTitle="Filter by Distance"
              valueComponent={DistanceValue}
              filterComponent={DistanceSelect}
              defaultFilters={defaultDistanceFilters}
            />
          ) : null
        }
      </DistanceFilterWrapper>
      {!isMobileOrTablet() && (
        <Filter
          type="location"
          modalTitle="Filter by Location"
          valueComponent={LocationValue}
          filterComponent={LocationSelect}
          defaultFilters={defaultLocationFilters}
        />
      )}
      <TagFilterWrapper>
        {({ isTagFilterVisible }) =>
          isTagFilterVisible && (
            <Filter
              type="tag"
              modalTitle="All Filters"
              valueComponent={TagValue}
              filterComponent={TagSelect}
              defaultFilters={defaultTagFilters}
            />
          )
        }
      </TagFilterWrapper>

      <Filter
        type="covid"
        modalTitle="Covid-19 Races"
        valueComponent={CovidValue}
        filterComponent={CovidSelect}
        defaultFilters={defaultCovidFilters}
      />
    </div>
  );
};

export default FilterBar;
